/**
 * Wood specific template for configurator
 * Converted from legacy JS to TypeScript
 */

import { ConfiguratorConfig } from '../types';
import translationInstance from '../utils/translations';
import PartialWood from './partialWood';

export const createWoodTemplate = (modelId: string): ConfiguratorConfig => {
  // Get translation function
  const t = translationInstance.t.bind(translationInstance);

  return {
    viewer: {
      modelId: modelId,
      background: {
        color: [0.91015625, 0.91015625, 0.91015625],
      },
      defaultActions: [],
    },
    configurator: {
      options: [
        PartialWood,
      ],
      queryConfig: true,
      selector: 'virtenzo-panel',
    },
  };
}
